export const choiceStrings = {
  choice: {
    name: 'Name',
    value: 'Wert',
    fieldName: 'Feldname',
    typeName: 'Typname',
    position: 'Sortierung',
    isDefault: 'Standard',
    isDefaultLong: 'Standardmäßig ausgewählt',
    modified: 'Geändert',
  },
  entitySingular: 'Auswahlfeld',
  entityPlural: 'Auswahlfelder',
  overview: {
    title: 'Auswahlfelder',
    description:
      'Wählen Sie eine Auswahlfeld-Kategorie aus, um die zugehörigen Einträge zu verwalten.',
    viewButton: 'Anzeigen',
  },
  choiceNames: {
    Priority: 'Prioritäten',
    CountryGroup: 'Ländergruppen',
    GoodList: 'Warenlisten',
    RequestType: 'Antragsarten',
    LegalBase: 'Rechtsgrundlagen',
    DossierType: 'Vorgangsarten',
    ApprovalFacts: 'Genehmigungstatbestände',
    SpecialPermissions: 'Besondere Genehmigungen',
    ImportExportTypes: 'Import/Export-Arten',
    OtherRequests: 'Sonstige Anträge',
    BusinessTypes: 'Geschäftsarten',
    Responsibility: 'Zuständigkeiten',
    Status: 'Status',
    RequestTypeApprovalType: 'Antragsarten-Genehmigungstypen',
    AdditionalFeatures: 'Zusätzliche Merkmale',
    DossierCountryGroup: 'Ländergruppen (Vorgang)',
    SubStatus: 'Unterstatus',
    ClosureType: 'Abschlussarten',
    DecisionLevel: 'Entscheidungsebenen',
    SpecialCondition: 'Besondere Bedingungen',
    CheckProgram: 'Prüfprogramme',
    DossierIdentifierType: 'Kennzeichentypen',
    DossierDateType: 'Datumstypen',
    DossierGoodCurrency: 'Währungen (Ware)',
    DossierGoodList: 'Warenlisten (Vorgang)',
    DossierGoodRequestedProcess: 'Beantragte Verfahren',
    DossierPartyIndustry: 'Branchen',
    DossierPartyRole: 'Rollen (Beteiligte)',
    DossierVoteVote: 'Voten',
    DossierVoteVoter: 'Votanten',
    DossierTransportationFrequencies: 'Häufigkeiten (Transport)',
    DossierTransportationConveyances: 'Transportmittel',
    DossierTransportation: 'Transportwege',
    Role: 'Rollen',
    Frequencies: 'Häufigkeiten',
    Currency: 'Währungen',
    CollateralClauseCategories: 'Kategorien (Nebenbestimmungen)',
    FeeCategories: 'Kategorien (Gebühren)',
    Kassenzeichen: 'Kassenzeichen',
  },
  messages: {
    archive: {
      success: (name: string) => `Auswahlfeld "${name}" wurde archiviert`,
      error: 'Auswahlfeld konnte nicht archiviert werden',
    },
    restore: {
      success: (name: string) =>
        `Auswahlfeld "${name}" wurde wiederhergestellt`,
      error: 'Auswahlfeld konnte nicht wiederhergestellt werden',
    },
    deletion: {
      success: (name: string) =>
        `Auswahlfeld "${name}" wurde erfolgreich gelöscht`,
      error: 'Auswahlfeld konnte nicht gelöscht werden',
      confirm: (name: string) =>
        `Möchten Sie das Auswahlfeld "${name}" wirklich löschen?`,
    },
    update: {
      success: 'Auswahlfeld erfolgreich aktualisiert',
      error: 'Auswahlfeld konnte nicht aktualisiert werden',
    },
    create: {
      success: 'Auswahlfeld erfolgreich erstellt',
      error: 'Auswahlfeld konnte nicht erstellt werden',
    },
    validation: {
      missingParams: 'Feldname und Typname sind erforderlich',
    },
  },
};
